import { tooglePleaseLogin } from "src/Store/reducer";
import { AppDispatch, RootState } from "@store/store";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import httpRequest from "src/helpers/httpRequest";
import HeartUnFav from "src/assets/images/heart-un-favorite.png";
import HeartFav from "src/assets/images/heart-favorite.png";
import {removeDisLike, updateDisLike, InitialState, updateDisLikeItem } from "src/Store/disLike";
import { toast } from "react-toastify";
import { Loader2 } from "lucide-react";
import { ILikedType } from "src/types/GlobalInterfaces";

interface IProps {
  id: string;
  index?: number;
  onLikeProduct?: ((id: string, status: boolean) => void) | undefined;
  liked?: boolean;
  category?: ILikedType
  className?: string;
  isWhishList?: boolean;
}

const FavoriteCoponent: React.FC<IProps> = ({
  id,
  liked,
  index,
  onLikeProduct,
  category = "tests",
  className,
  isWhishList = false,
}) => {
  const { dislikeItem } = useSelector((store: RootState) => store.disLike);
  const [likedStatus, setLikedStatus] = useState<boolean>(liked || false);

  const [loader, setLoader] = useState<boolean>(false);

  const convertCategoryToKey = (category: string) => {
    return category === "pharmacy"
      ? "pharmacyDisLike"
      : category === "tests"
      ? "testsDisLike"
      : category === "package"
      ? "packageDisLike"
      : category === "diagnostic-product"
      ? "testsDisLike"
      : category === "homecare"
      ? "homecareDisLike"
      : category === "doctor"
      ? "doctorDisLike"
      : "";
  };

  useEffect(() => {
    if(dislikeItem.id === id && dislikeItem.type === category) {
      setLikedStatus(false);
      dispatch(updateDisLikeItem({ id: "", type: "" }));
    }
  }, [dislikeItem]);

  const dispatch = useDispatch<AppDispatch>();
  const { isLogged } = useSelector((store: RootState) => store.appReducer);


  const toggleFavorite = async (like: boolean = false) => {
    // setIsLiked(like);
    if(loader) return;
    setLoader(true);
    const method = "get";
    const path =
      category === "pharmacy"
        ? `/inventory-favProduct/toggle/${id}`
        : category === "tests"
        ? `/product/toggle/${id}`
        : category === "package"
        ? `/diagnostic-package/toggle/${id}`
        : category === "diagnostic-product"
        ? `/product/toggle/${id}`
        : category === "homecare"
        ? `/home-care-services/toggle/${id}`
        : category === "doctor"
        ? `/provider/toggle/${id}`
        : "";
    const { res, err } = await httpRequest<{
      message: string;
      isLiked: boolean;
    }>({ method, path });
    if (res) {
      const { message = "", isLiked = false } = res;
      // toast(message, { type: "success" });
      if (!isLiked && isWhishList) {
        dispatch(updateDisLikeItem({ id, type: category }));
      } else if (isWhishList) {
        const key = convertCategoryToKey(category);
        dispatch(
          removeDisLike({
            key: key as InitialState,
            value: id,
          })
        );
      }
      setLikedStatus(isLiked);
      onLikeProduct && onLikeProduct(id, isLiked);
    } else {
      // setIsLiked(!like);
      console.log("ERROR", err);
      toast("Failed to Fav/Unfav", { type: "error" });
    }
    setLoader(false);
  };
  return (
    <button
      className={`w-[25px] h-[25px] group lg:w-[27px] lg:h-[27px] 2xl:w-[35px] 2xl:h-[35px] cursor-pointer bg-[#E4E4E4] rounded-full flex items-center justify-center ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        isLogged ? toggleFavorite(!likedStatus) : dispatch(tooglePleaseLogin(true));
      }}
      id={
        index || index === 0 ? `favorite-component-${index + 1}` : "heart-icon"
      }
    >
      {loader ? (
        <Loader2 className="animate-spin lg:w-[1vw] lg:h-[1vw] w-[15px] h-[15px]" />
      ) : (
        <img
          src={isLogged && likedStatus ? HeartFav : HeartUnFav}
          alt="HeartUnFav"
          className={`w-[60%] group-active:scale-75 transition-all`}
        />
      )}
    </button>
  );
};

export default FavoriteCoponent;
